import MainBlock from "components/DesignSystem/LayoutBlocks/MainBlock";
import React from "react";
import exclaims from "assets/exclaims.json";
import { arrayRandom } from "Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { thin } from "@fortawesome/fontawesome-svg-core/import.macro";

export default function AuditScreen(props) {
    return (
        <MainBlock>
            <div className="mx-auto max-w-xl rounded-lg bg-white p-4 shadow-lg">
                <div className="my-4 space-y-4 text-center text-gray-700">
                    <FontAwesomeIcon
                        className="text-5xl text-gray-300"
                        icon={thin("triangle-exclamation")}
                    />
                    <div className="text-xl font-bold">
                        {arrayRandom(exclaims)}
                    </div>
                    <hr />
                    <div className="font-normal tracking-tighter">
                        This feature is still under development
                    </div>
                </div>
            </div>
        </MainBlock>
    );
}
